// extracted by mini-css-extract-plugin
export default {"infoBlock":"views-ContentPage-components-themes-BGH-seo__infoBlock--t03Mr","description":"views-ContentPage-components-themes-BGH-seo__description--tFkkC"};